import { FC } from 'react';

import { Document } from 'types';
import { ReplaceDocumentTagsSources } from 'modules/documents/api/replaceDocumentTags';

import DownloadDocument from './components/DownloadDocument';
import DocumentSpinner from './components/DocumentsSpinner';
import DocumentsOptionsList from './components/DocumentsOptionsList';

type DocumentsColumnProps = {
  index: number;
  documentsCount: number;
  documents: Document[];
  hideOnMobile?: boolean;
  tableView?: boolean;
  sources?: ReplaceDocumentTagsSources;
  templateWatermarkText?: string;
  isLandscape?: boolean;
  className?: string;
};

const DocumentsColumn: FC<DocumentsColumnProps> = ({
  index,
  documentsCount,
  documents,
  hideOnMobile = true,
  tableView = true,
  sources,
  templateWatermarkText = '',
  isLandscape = false,
}) => {
  const className = tableView
    ? `nk-tb-col ${hideOnMobile ? 'tb-col-xl' : ''} text-center align-middle`
    : `nk-file-${hideOnMobile ? 'members' : 'meta'} align-middle`;

  const showLoadedDocuments = () => {
    if (documents?.length === 1) {
      return (
        <DownloadDocument
          document={documents[0]}
          sources={sources}
          templateWatermarkText={templateWatermarkText}
          isLandscape={isLandscape}
        />
      );
    }
    if (documentsCount > 1) {
      if (documents.length === 1) {
        return <DocumentSpinner />;
      }
      return <DocumentsOptionsList documents={documents} />;
    }
    return <span>-</span>;
  };

  const content =
    documentsCount > 0 ? (
      showLoadedDocuments()
    ) : (
      <span className="btn btn-icon disabled">
        <em className="icon ni ni-file-download" />
      </span>
    );

  return tableView ? (
    <td className={className} key={`document-column-${index}`}>
      {content}
    </td>
  ) : (
    <div className={className} key={`document-column-${index}`}>
      {content}
    </div>
  );
};

export default DocumentsColumn;
